import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// import { AuthHttp } from 'auth0/angular-jwt';

import { Headers, Http, Request, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { Company } from './company.model';
import { QueriedCompany } from './companyAPI.model';

// import company from '../../../../server/models/company';

import { } from 'googlemaps';
// import { } from 'googlemaps';
import { InvestmentTypes, OpportunitySourceTypes, BusinessRelationshipTypes, IndustryCategories, InvestorTypes, InvestmentPreferredDealTypes, InvestmentGeographicalPreferences, InvestmentPreferredCompanyValuations, InvestmentPreferredInvestmentAmounts, InvestmentPreferredRevenueCharacteristics, InvestmentPreferredProfitCharacteristics } from './company.enums';
import { EnumTextValuesPipe } from '../../shared/pipes/enum-keys-text.pipe';
import { EnumKeysPipe } from '../../shared/pipes/enum-keys.pipe';
import { EnumStringsPipe } from '../../shared/pipes/enum-strings.pipe';
import { Contact } from '../contacts/contact.model';
import * as _ from 'lodash';
import { EventBB } from '../events/event.model';
import { Project } from '../projects/project.model';
import { Task } from '../../shared/tasks/task.model';
import { Attachment } from '../../shared/attachments/attachment.model';
import { Address } from '../../shared/models/address.model';


@Injectable()
export class CompanyService {

  keepSubscriptionsAlive: boolean = false;

  /* used for the enum select options */
  opportunitySourceTypesOptions: any = this.enumTextValuesPipe.transform(OpportunitySourceTypes, ['']);
  businessRelationshipTypesOptions: any = this.enumTextValuesPipe.transform(BusinessRelationshipTypes, ['']);
  industryTypesOptions: any = this.enumTextValuesPipe.transform(IndustryCategories, ['']);

  /* investor drop downs */
  investmentTypesOptions: any = this.enumStringsPipe.transform(InvestmentTypes, ['']);
  investorTypesOptions: any = this.enumTextValuesPipe.transform(InvestorTypes, ['']);
  investmentPreferredDealTypesOptions: any = this.enumTextValuesPipe.transform(InvestmentPreferredDealTypes, ['']);
  investmentGeographicalPreferencesOptions: any = this.enumTextValuesPipe.transform(InvestmentGeographicalPreferences, ['']);
  investmentPreferredCompanyValuationsOptions: any = this.enumStringsPipe.transform(InvestmentPreferredCompanyValuations, ['']);
  investmentPreferredInvestmentAmountsOptions: any = this.enumStringsPipe.transform(InvestmentPreferredInvestmentAmounts, ['']);
  investmentPreferredRevenueCharacteristicsOptions: any = this.enumStringsPipe.transform(InvestmentPreferredRevenueCharacteristics, ['']);
  investmentPreferredProfitCharacteristicsOptions: any = this.enumStringsPipe.transform(InvestmentPreferredProfitCharacteristics, ['']);



  constructor(public http: HttpClient,
    public enumTextValuesPipe: EnumTextValuesPipe,
    public enumKeyValuesPipe: EnumKeysPipe,
    public enumStringsPipe: EnumStringsPipe
  ) { }

  addContactToCompany(company: Company, contact: Contact) {

    // create a clone and a spoof company and use the id - otherwise we get a json circular reference
    const clone = _.cloneDeep(company);

    const spoofContact = new Contact();
    spoofContact._id = contact._id;

    // push the spoofed company to the team member
    clone.employees.unshift(spoofContact);

    // console.log('saving company to teamMember');
    this.saveCompany(clone);

  }

  removeContactFromCompany(company: Company, contact: Contact) {

    // find the contact index in the array
    const foundIndex = company.employees.findIndex(c => c._id === contact._id);

    // move it to the front
    if (foundIndex !== -1) {

      // and remove it
      company.employees.splice(foundIndex, 1);

    }

    console.log('removing employee from company');
    this.saveCompany(company);

  }

  addEventToCompany(company: Company, event: EventBB) {

    // create a clone and a spoof company and use the id - otherwise we get a json circular reference
    const clone = _.cloneDeep(company);

    const spoofEvent = new EventBB();
    spoofEvent._id = spoofEvent._id;

    // push the spoofed company to the team member
    if (clone.events === undefined) { clone.events = []; }
    clone.events.unshift(spoofEvent);

    // console.log('saving company to teamMember');
    this.saveCompany(clone);

  }

  removeEventFromCompany(company: Company, event: EventBB) {

    // find the contact index in the array
    const foundIndex = company.events.findIndex(e => e._id === event._id);

    // move it to the front
    if (foundIndex !== -1) {
      // and remove it
      company.events.splice(foundIndex, 1);
    }

    console.log('removing event from company');
    this.saveCompany(company);

  }

  addTaskToCompany(company: Company, task: Task) {

    // create a clone and a spoof company and use the id - otherwise we get a json circular reference
    const clone: Company = _.cloneDeep(company);

    const spoofTask = new Task();
    spoofTask._id = task._id;

    // push the spoofed company to the team member
    clone.tasks.unshift(spoofTask);

    // console.log('saving company to teamMember');
    this.saveCompany(clone);

  }

  addAttachmentToCompany(company: Company, attachment: Attachment) {

    // create a clone and a spoof company and use the id - otherwise we get a json circular reference
    const clone: Company = _.cloneDeep(company);

    const spoofAttachment = new Attachment();
    spoofAttachment._id = attachment._id;

    // push the spoofed company to the team member
    clone.attachments.unshift(spoofAttachment);

    // console.log('saving company to teamMember');
    this.saveCompany(clone);

  }

  saveCompany(company: Company) {

    this.keepSubscriptionsAlive = true;
    // console.log(this.company);
    this.editCompany(company)
      .takeWhile(() => this.keepSubscriptionsAlive)
      .subscribe(
        res => {
          console.log('Company edited successfully.');
          this.keepSubscriptionsAlive = false;
        },
        error => {
          console.log(error);
        }
      );
  }

  // addProjectToCompany(company: Company, project: Project) {

  //   // create a clone and a spoof company and use the id - otherwise we get a json circular reference
  //   const clone = _.cloneDeep(company);

  //   const spoofProject = new Project();
  //   spoofProject._id = project._id;

  //   // push the spoofed company to the team member
  //   clone..unshift(spoofProject);

  //   // console.log('saving company to teamMember');
  //   this.saveCompany(clone);

  // }


  searchCompanies(searchString: string): Observable<Company[]> {
    // see https://github.com/surfer77/mongoose-string-query for full API!
    return this.http.get<Company[]>('/api/companies/search?' + searchString, {
      headers: { ignoreLoadingBar: '' }
    }).map((companies: Company[]) => {
      return companies;
    }).catch(this.handleError);

  }

  findCompaniesByQuery(queryString: string): Observable<Company[]> {
    return this.http.get<Company[]>(`/api/companies/findByQuery/${queryString}`, {
      // headers: { ignoreLoadingBar: '' }
    }).map((companies: Company[]) => {
      return companies;
    }).catch(this.handleError);

  }

  findCompanies(searchString: string): Observable<Company[]> {

    if (searchString === undefined || searchString === '') { searchString = ' '; }

    return this.http.get<Company[]>(`/api/companies/find/${searchString}`, {
      headers: { ignoreLoadingBar: '' }
    }).map((companies: Company[]) => {
      return companies;
    }).catch(this.handleError);

  }

  findCompaniesIncEmployees(): Observable<Company[]> {

    return this.http.get<Company[]>(`/api/companies/findIncEmployees`, {
      headers: { ignoreLoadingBar: '' }
    }).map((companies: Company[]) => {
      return companies;
    }).catch(this.handleError);

  }

  findTopNCompanies(searchString: string, limit: number = 5): Observable<Company[]> {

    if (searchString === undefined || searchString === '') { searchString = ' '; }

    return this.http.get<Company[]>(`/api/companies/find/top/${searchString}/${limit}`, {
      // headers: { ignoreLoadingBar: '' }
    }).map((companies: Company[]) => {
      return companies;
    }).catch(this.handleError);

  }

  findTopNCompaniesWithEmployees(searchString: string, limit: number = 5): Observable<Company[]> {

    if (searchString === undefined || searchString === '') { searchString = ' '; }

    return this.http.get<Company[]>(`/api/companies/find/topWithEmployees/${searchString}/${limit}`, {
      headers: { ignoreLoadingBar: '' }
    }).map((companies: Company[]) => {
      return companies;
    }).catch(this.handleError);

  }

  findTopNAmbassadorCompanies(searchString: string, limit: number = 5): Observable<Company[]> {

    if (searchString === undefined || searchString === '') { searchString = ' '; }

    return this.http.get<Company[]>(`/api/companies/find/topAmbassadors/${searchString}/${limit}`, {
      headers: { ignoreLoadingBar: '' }
    }).map((companies: Company[]) => {
      return companies;
    }).catch(this.handleError);

  }


  // Defines routes for company data retrieval
  getCompanys(): Observable<Company[]> {
    return this.http.get<Company[]>('/api/companies').map((companies: Company[]) => {
      return companies;
    }).catch(this.handleError);
  }

  countCompanys(): Observable<number> {
    return this.http.get<number>('/api/companies/count');
  }

  addCompany(company: Company): Observable<Company> {
    console.log(company);
    return this.http.post<Company>('/api/company', company);
  }

  anyCompanyAlreadyExist(companies: any[]): Observable<any> {
    return this.http.post<any>('/api/anyCompanyAlreadyExist', companies);
  }


  getCompanyFromId(id: string): Observable<Company> {
    return this.http.get<Company>(`/api/company/${id}`);
  }

  getCompany(company: Company): Observable<Company> {
    return this.http.get<Company>(`/api/company/${company._id}`);
  }

  editCompany(company: Company): Observable<string> {
    return this.http.put(`/api/company/${company._id}`, company, { responseType: 'text' });
  }

  deleteCompany(company: Company): Observable<string> {
    return this.http.delete(`/api/company/${company._id}`, { responseType: 'text' });
  }

  getCompaniesCreatedFromTo(from: string, to: string): Observable<Company[]> {
    return this.http.get<Company[]>(`/api/companies/byDate/${from}/${to}`);
  }


  queryCompanyLogo(domain: string) {
    return this.http.get<QueriedCompany>(`https://logo.clearbit.com/${domain}`);
  }



  queryCompanyData(companySearch: string) {
    return this.http.get<QueriedCompany>(`https://autocomplete.clearbit.com/v1/companies/suggest?query=${companySearch}`);
  }

  //searchCX = '013879053156050701981:34bjb-mohu4'; // tslint:disable-line:member-ordering
  //searchAPI = 'AIzaSyC4zebKI4czza4wAdMJhzyjV230O6P4B0M'; // tslint:disable-line:member-ordering
  searchCX = '395f3674097fa0c98'; // tslint:disable-line:member-ordering
  searchAPI = 'AIzaSyBm2OnD1VSw50CRkKCW0lHpqp21ioE5BBc'; // tslint:disable-line:member-ordering


  queryCompanyDataFromGoogle(companySearch: string) {
    return this.http.get<any>(`https://www.googleapis.com/customsearch/v1?key=${this.searchAPI}&cx=${this.searchCX}&q=${companySearch}`); // tslint:disable-line:max-line-length
  }

  // function that takes a google address and translates to a bluebox one.
  translateAddress(placeResult: any): Address {

    const place: google.maps.places.PlaceResult = <google.maps.places.PlaceResult>placeResult;
    const placeAddress = new Address();
    const addressComp = {};

    /* jquery function that translates the address components to a more usable object */
    jQuery.each(place.address_components, function (k, v1) { jQuery.each(v1.types, function (k2, v2) { addressComp[v2] = v1.long_name; }); });
    console.log(addressComp);

    /* calculate a street address */
    const streetAddress = addressComp['street_number'] !== undefined ? addressComp['street_number'] + ' ' : '';
    const streetName = addressComp['route'] !== undefined ? addressComp['route'] : '';

    // apply the street address - this is not perfect!
    if (addressComp['premise'] !== undefined) {
      placeAddress.line1 = addressComp['premise'];
      placeAddress.line2 = streetAddress + streetName;
    } else {
      placeAddress.line1 = streetAddress + streetName;
      placeAddress.line2 = addressComp['neighborhood'] !== undefined ? addressComp['neighborhood'] : addressComp['sublocality'] !== undefined ? addressComp['sublocality'] : ' ';
    }

    placeAddress.city = addressComp['postal_town'] !== undefined ? addressComp['postal_town'] : addressComp['locality'] !== undefined ? addressComp['locality'] : '';
    placeAddress.county = addressComp['administrative_area_level_2'] !== undefined ? addressComp['administrative_area_level_2'] : '';
    placeAddress.postcode = addressComp['postal_code'] !== undefined ? addressComp['postal_code'] : '';
    placeAddress.country = addressComp['country'] !== undefined ? addressComp['country'] : '';

    return placeAddress;

  }

  private handleError(error: Response) {
    return Observable.throw(error.statusText);
  }


}



// WEBPACK FOOTER //
// ./client/app/features/companies/company.service.ts